export class CountdownDto {

    constructor (id, name, endingDateAndTime) {
        this._id = id;
        this._name = name;
        this._endingDateAndTime = endingDateAndTime;
    };

};